import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import * as React from 'react'

import { Category } from './CategoryPage/GetCategory.query'
import { Breadcrumbs } from '../navigation/Breadcrumbs'
import { filterNullValues } from '../utils/filterNullValues'

interface OwnProps {
    category: Category
}

type Props = OwnProps

const CategoryBreadcrumbs = ({ category }: Props) => {
    const fullCategoryUrl: string[] = []
    const breadcrumbs = [
        {
            to: '/',
            label: t({
                id: 'catalog.categoryBreadcrumbs.homeLabel',
                message: `Home`,
            }),
        },
    ]

    const catBreadcrumbs = filterNullValues(category.breadcrumbs)

    if (catBreadcrumbs) {
        const copy = [...catBreadcrumbs]

        copy.sort(
            (a, b) => (a.categoryLevel ?? 0) - (b.categoryLevel ?? 0),
        ).forEach((cat) => {
            if (cat.categoryUrlKey) {
                fullCategoryUrl.push('/', cat.categoryUrlKey)
                breadcrumbs.push({
                    to: fullCategoryUrl.join(''),
                    label: cat?.categoryName ?? '',
                })
            }
        })
    }

    if (category.urlKey) {
        fullCategoryUrl.push('/', category.urlKey)
        breadcrumbs.push({
            to: fullCategoryUrl.join(''),
            label: category.name ?? '',
        })
    }

    return (
        <Breadcrumbs>
            {breadcrumbs.map(({ to, label }, index) => (
                <Breadcrumbs.Link key={to} to={to} position={index + 1}>
                    {label}
                </Breadcrumbs.Link>
            ))}
        </Breadcrumbs>
    )
}

export default CategoryBreadcrumbs
